import { action } from 'satcheljs';
export default action('TOGGLE_DARK_MODE_THEME', function (isDarkModeEnabled) { return ({
    isDarkModeEnabled: isDarkModeEnabled,
}); });
//# sourceMappingURL=toggleDarkModeTheme.js.map